L.Control.Loader = L.Control.extend({
  options: {
    position: "topleft",
  },
  _isVisible: false,

  onAdd: function (map) {
    this._map = map;

    // create controler container
    var container = L.DomUtil.create(
      "div",
      "leaflet-control-loader leaflet-control"
    );

    // add loader container
    this.loaderContainer = L.DomUtil.create(
      "div",
      "leaflet-control-loader-container",
      container
    );
    this.loaderContainer.style.display = "none";

    this.loaderContainer.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="24px" height="24px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
    <circle cx="50" cy="50" fill="none" stroke="#6f6f6f" stroke-width="8" r="34" stroke-dasharray="160.22122533307947 55.40707511102649">
      <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.641025641025641s" values="0 50 50;360 50 50" keyTimes="0;1"/>
    </circle></svg>`;

    return container;
  },

  _show: function () {
    this.loaderContainer.style.display = "block";
  },

  _hide: function () {
    this.loaderContainer.style.display = "none";
  }
});

L.control.loader = function (options) {
  return new L.Control.Loader(options);
};
